import { TextureLoader, PlaneGeometry, MeshStandardMaterial, Mesh, RepeatWrapping } from 'three';
import { useEffect, useRef } from 'react';
import groundTexture from '../../assets/groundTexture.jpg';


function Terrain({ 
  heightImg, 
  alphaImg, 
  scale = 1, 
  settings,
  scene
}) {

  const terrainRef = useRef();
  const materialRef = useRef();
  const height = 0;
  const minHeight = 2;
  let t = 0;

  useEffect(() => {
    if (!terrainRef.current) {
      loadEnvironment();
    }
    return () => {
      if (terrainRef.current) {
        scene.remove(terrainRef.current);
      }
    }; // Clean up on unmount
  }, []);
  useEffect(() => {
    if (terrainRef.current) {
      terrainRef.current.visible = settings.show;
    }
    
  }, [settings.show]);

  const loadEnvironment = async () => {
    // console.log("loadEnvironment");

    const textureLoader = new TextureLoader();
    const texture = await new Promise((resolve, reject) => {
      textureLoader.load(groundTexture, resolve, undefined, reject);
    });
    texture.wrapS = RepeatWrapping;
    texture.wrapT = RepeatWrapping;
    texture.repeat.set(20, 20); // Adjust the repeat values as needed

    const geometry = new PlaneGeometry(10000, 10000, 64, 64);
    // console.log({ texture });
    const planeMaterial = new MeshStandardMaterial({ color: 0x808080 });
    materialRef.current = new MeshStandardMaterial({
      // color: "white",
      map: texture,
      transparent: false,
      depthTest: true,
    });

    const plane = new Mesh(geometry, materialRef.current);
    plane.castShadow = true; // Enable shadow casting for the model
    plane.receiveShadow = true; // Enable shadow receiving for the model
    plane.scale.set(scale, scale, scale);
    plane.position.y = height;
    plane.rotation.x = -Math.PI / 2;

    terrainRef.current = plane;
    terrainRef.current.visible = settings.show;
    // console.log("terrainRef.current", terrainRef.current);
    scene.add(terrainRef.current);
  };

  return null;
}

export default Terrain;